import { render } from "./UnitSelect.vue?vue&type=template&id=f8a1e8fc"
import script from "./UnitSelect.vue?vue&type=script&lang=js"
export * from "./UnitSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__